import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router';
import VueMoment from 'vue-moment';
import VueQuillEditor from 'vue-quill-editor';
import './plugins/firebase';
import firebase from 'firebase/compat/app';
import theme from './plugins/theme';
import utils from './plugins/utils';
import rules from './plugins/rules';
import database from './plugins/database';
import sms from './plugins/sms';
import auth from './plugins/auth';
import storage from './plugins/storage';
import models from './plugins/models';

// pages
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import PolicyDocument from './pages/PolicyDocument';
import AppLinkPage from './pages/deeplink/AppLinkPage';
import DesignerDetailLinkPage from './pages/deeplink/DesignerDetailLinkPage';

// components
import ListItem from './templates/ListItem';
import MessageDialog from './templates/MessageDialog';
import FilePicker from './templates/FilePicker';
import ImageViewer from './templates/ImageViewer';
import FileNameViewer from './templates/FileNameViewer';
import Settings from './templates/Settings';
import Waiting from './templates/Waiting';
import ContentEditor from './templates/ContentEditor';

// import theme style
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import './assets/css/global.css';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueMoment);
Vue.use(VueQuillEditor);

Vue.component(ListItem.name, ListItem);
Vue.component(MessageDialog.name, MessageDialog);
Vue.component(FilePicker.name, FilePicker);
Vue.component(ImageViewer.name, ImageViewer);
Vue.component(FileNameViewer.name, FileNameViewer);
Vue.component(Settings.name, Settings);
Vue.component(Waiting.name, Waiting);
Vue.component(ContentEditor.name, ContentEditor);

import UserManager from './components/user/UserManager';
import UserList from './components/user/UserList';
import UserEditDialog from './components/user/UserEditDialog';
Vue.component(UserManager.name, UserManager);
Vue.component(UserList.name, UserList);
Vue.component(UserEditDialog.name, UserEditDialog);

import DesignerManager from './components/designer/DesignerManager';
import DesignerList from './components/designer/DesignerList';
import DesignerEditDialog from './components/designer/DesignerEditDialog';
import DesignerMenuList from './components/designer/DesignerMenuList';
import DesignerMenuEditDialog from './components/designer/DesignerMenuEditDialog';
Vue.component(DesignerManager.name, DesignerManager);
Vue.component(DesignerList.name, DesignerList);
Vue.component(DesignerEditDialog.name, DesignerEditDialog);
Vue.component(DesignerMenuList.name, DesignerMenuList);
Vue.component(DesignerMenuEditDialog.name, DesignerMenuEditDialog);

import ReservationEditDialog from './components/appointment/ReservationEditDialog';
import SelectReservationDialog from './components/appointment/SelectReservationDialog';
import SelectReservationList from './components/appointment/SelectReservationList';
Vue.component(ReservationEditDialog.name, ReservationEditDialog);
Vue.component(SelectReservationDialog.name, SelectReservationDialog);
Vue.component(SelectReservationList.name, SelectReservationList);

import StoreManager from './components/store/StoreManager';
import StoreList from './components/store/StoreList';
import StoreEditDialog from './components/store/StoreEditDialog';
Vue.component(StoreManager.name, StoreManager);
Vue.component(StoreList.name, StoreList);
Vue.component(StoreEditDialog.name, StoreEditDialog);

import AlertManager from './components/alert/AlertManager';
import AlertSendForm from './components/alert/AlertSendForm';
import AlertHistoryList from './components/alert/AlertHistoryList';
Vue.component(AlertManager.name, AlertManager);
Vue.component(AlertSendForm.name, AlertSendForm);
Vue.component(AlertHistoryList.name, AlertHistoryList);

import BannerManager from './components/banner/BannerManager';
import BannerList from './components/banner/BannerList';
import BannerEditDialog from './components/banner/BannerEditDialog';
Vue.component(BannerManager.name, BannerManager);
Vue.component(BannerList.name, BannerList);
Vue.component(BannerEditDialog.name, BannerEditDialog);

import MenuManager from './components/menu/MenuManager';
import MenuClassList from './components/menu/MenuClassList';
import MenuList from './components/menu/MenuList';
import MenuEditDialog from './components/menu/MenuEditDialog';
import MenuClassSelectDialog from './components/menu/MenuClassSelectDialog';
Vue.component(MenuManager.name, MenuManager);
Vue.component(MenuClassList.name, MenuClassList);
Vue.component(MenuList.name, MenuList);
Vue.component(MenuEditDialog.name, MenuEditDialog);
Vue.component(MenuClassSelectDialog.name, MenuClassSelectDialog);

import PrivacyPolicy from './components/policy/PrivacyPolicy';
import TermService from './components/policy/TermService';
import TermServiceDesigner from './components/policy/TermServiceDesigner.vue';
import TermServiceCustomer from './components/policy/TermServiceCustomer.vue';
import ElectronicCommerce from './components/policy/ElectronicCommerce';
Vue.component(PrivacyPolicy.name, PrivacyPolicy);
Vue.component(TermService.name, TermService);
Vue.component(ElectronicCommerce.name, ElectronicCommerce);

import AppVersionManager from './components/app/AppVersionManager';
import AppVersionForm from './components/app/AppVersionForm';
Vue.component(AppVersionManager.name, AppVersionManager);
Vue.component(AppVersionForm.name, AppVersionForm);

const router = new VueRouter({
	mode: 'history',
	routes: [
		{ path: '/', meta: { requireAuth: true }, component: HomePage },
		{ path: '/Login', component: LoginPage },
		{ path: '/policy', meta: { noAuth: true }, component: PolicyDocument },
		{ path: '/policy/:param', meta: { noAuth: true }, component: PolicyDocument },
		{ path: '/policy-designer', meta: { noAuth: true }, component: TermServiceDesigner },
		{ path: '/policy-customer', meta: { noAuth: true }, component: TermServiceCustomer },
		{ path: '/a', meta: { noAuth: true }, component: AppLinkPage }, // 앱 딥링크
		{ path: '/d', meta: { noAuth: true }, component: DesignerDetailLinkPage }, // 디자이너 상세 딥링크
	],
});

router.beforeEach((to, from, next) => {
	// noAuth 경로 먼저 확인
	if (to.matched.some(record => record.meta.noAuth)) {
		next();
	} else if (to.matched.some(record => record.meta.requireAuth)) {
		firebase.auth().onAuthStateChanged(function(user) {
			if (user) {
				next();
			} else {
				next({ path: '/Login' });
			}
		});
	} else {
		next();
	}
});

new Vue({
	vuetify,
	router,
	firebase,
	theme,
	utils,
	rules,
	database,
	auth,
	storage,
	models,
	sms,
	render: h => h(App),
}).$mount('#app');
